(function employeeFileMassiveImportModuleDefinition() {
    'use strict';

    angular.module('EmployeeFileMassiveImport', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function employeeFileMassiveImportConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('employee-file-massive-import-find', {
                    url: "/EmployeeFileMassiveImport/Find",
                    templateUrl: config.resourceUrl('/views/employee-file-massive-import/employee-file-massive-import-find.html'),
                    controller: 'EmployeeFileMassiveImportFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE MULTIPLE WRITE').or('EMPLOYEEFILE READ')
                });

                $stateProvider.state('employee-file-massive-import-add', {
                    url: "/EmployeeFileMassiveImport/Add",
                    templateUrl: config.resourceUrl('/views/employee-file-massive-import/employee-file-massive-import-add.html'),
                    controller: 'EmployeeFileMassiveImportAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('EMPLOYEEFILE MULTIPLE WRITE')
                });
            }
        ]);
})();
